/** @format */
import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	DestroyRef,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	Output,
	PLATFORM_ID,
	inject,
	viewChild
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronLeft,
	homefieldIconChevronRight
} from '@dsg-tech/homefield-angular-icons';

import { ProductReviewSliderType } from '@product-reviews/data-access';

@Component({
	selector: 'product-reviews-review-slider',
	templateUrl: './review-slider.component.html',
	styleUrl: './review-slider.component.scss',
	imports: [CommonModule, HomefieldIconLibraryModule]
})
export class ReviewSliderComponent implements AfterViewInit, OnDestroy {
	homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	@Input() selector = `container-${Math.random()}`;
	@Input() activeScroll = true;
	@Output() buttonDirection = new EventEmitter<string>();

	readonly scrollableContainer = viewChild.required<ElementRef>('scrollableList');

	private readonly ref = inject(ChangeDetectorRef);
	readonly destroyRef = inject(DestroyRef);
	readonly platformId = inject(PLATFORM_ID);

	showLeftArrow = false;
	showRightArrow = false;
	private observer: MutationObserver;

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronRight,
			homefieldIconChevronLeft
		]);
	}

	// After the view is initialized, attach a scroll event listener
	ngAfterViewInit() {
		if (isPlatformBrowser(this.platformId)) {
			// Wait for element to render and modal to animate before calculating scroll
			setTimeout(() => {
				this.refreshArrowVisibility();
			}, 100);

			this.listenForCarouselContentChanges();
		}

		this.buttonDirection.emit(ProductReviewSliderType.NONE);
		this.ref.detectChanges();
	}

	ngOnDestroy(): void {
		if (this.observer) {
			this.observer.disconnect();
		}
	}

	listenForCarouselContentChanges(): void {
		// Set up a MutationObserver to detect changes to the carousel content
		this.observer = new MutationObserver(() => {
			// Check if the carousel content is overflowing
			this.refreshArrowVisibility();
		});

		// Observe the carousel content for changes
		this.observer.observe(this.scrollableContainer().nativeElement, {
			childList: true,
			subtree: true
		});
	}

	refreshArrowVisibility() {
		const scrollList = this.scrollableContainer().nativeElement;
		this.showLeftArrow = !!scrollList?.scrollLeft;
		this.showRightArrow =
			scrollList?.scrollWidth > scrollList?.scrollLeft + scrollList?.clientWidth;
	}

	// Emit a custom callback event (not implemented in the provided code)
	scrollList(direction: string): void {
		const container = document.querySelector(`#${this.selector}`);
		const scrollAmount = (container.firstChild.childNodes[0] as HTMLElement).scrollWidth;
		if (container) {
			if (direction === ProductReviewSliderType.LEFT) {
				container.scrollLeft -= scrollAmount;
				this.buttonDirection.emit(ProductReviewSliderType.LEFT);
			} else {
				container.scrollLeft += scrollAmount;
				this.buttonDirection.emit(ProductReviewSliderType.RIGHT);
			}
		}
	}
}
